export default __webpack_public_path__ + "static/media/export.cca0d437.svg";